import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { Link as ScrollLink } from "react-scroll";

const Menu = (props) => (
  <nav id="menu">
    <div className="inner">
      <ul className="links">
        <li>
          <Link onClick={props.onToggleMenu} to="/">
            Home
          </Link>
        </li>
        <li>
          <ScrollLink smooth={true} onClick={props.onToggleMenu} to="services">
            Services
          </ScrollLink>
        </li>
        <li>
          <ScrollLink smooth={true} onClick={props.onToggleMenu} to="contact">
            Contact
          </ScrollLink>
        </li>
        <li>
          <Link onClick={props.onToggleMenu} to="/privacy_policy">
            Privacy Policy
          </Link>
        </li>
      </ul>
    </div>
    <a className="close" onClick={props.onToggleMenu} href="javascript:;">
      Close
    </a>
  </nav>
);

Menu.propTypes = {
  onToggleMenu: PropTypes.func,
};

export default Menu;
